export default "/images/download.svg?bcdf741cca364364240728b1f6fb81e4";